import { render, staticRenderFns } from "./Color.vue?vue&type=template&id=330dbf3d&scoped=true"
import script from "./Color.vue?vue&type=script&lang=js"
export * from "./Color.vue?vue&type=script&lang=js"
import style0 from "./Color.vue?vue&type=style&index=0&id=330dbf3d&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "330dbf3d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('330dbf3d')) {
      api.createRecord('330dbf3d', component.options)
    } else {
      api.reload('330dbf3d', component.options)
    }
    module.hot.accept("./Color.vue?vue&type=template&id=330dbf3d&scoped=true", function () {
      api.rerender('330dbf3d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/infra/rubricSetting/Add/components/Color.vue"
export default component.exports